export default {"src":"/_next/static/media/user.d52724c6.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};